import React, { Suspense } from "react";
import { Route, Routes } from "react-router";
import AuthRouteWrapper from "./AuthRouteWrapper";
import ProtectedRouteWrapper from "./ProtectedRouteWrapper";
import routes from "./routeConfig.js";
import { Spin } from "antd";
import AdminLayout from "../layout/AdminLayout.js";
import Loader from "../Components/Loader";

const NavigationManager = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        {routes
          .filter((route) => route.layout === "AdminLayout")
          .map(({ path, component:Component, wrapRoute }) => {
            const WrappedComponent = () => (
              <Suspense
                fallback={
                  <Spin
                    size="large"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                      width: "100%",
                    }}
                  />
                }
              >
                <Component />
              </Suspense>
            );

            switch (wrapRoute) {
              case "AuthRoute":
                return (
                  <Route key={path} element={<AuthRouteWrapper />}>
                    <Route path={path} Component={WrappedComponent} />
                  </Route>
                );
              case "ProtectedRoute":
                return (
                  <Route key={path} element={<ProtectedRouteWrapper />}>
                    <Route path={path} Component={WrappedComponent} />
                  </Route>
                );
              default:
                return (
                  <Route key={path} path={path} Component={WrappedComponent} />
                );
            }
          })}
      </Route>

      {routes
        .filter(
          (route) =>
            route.layout !== "AdminLayout" || route.layout !== "MainLayout"
        )
        .map(({ path, component, wrapRoute }) => {
          const WrappedComponent = () => (
            <Suspense fallback={<Loader />}>
              {React.createElement(component)}
            </Suspense>
          );

          switch (wrapRoute) {
            case "AuthRoute":
              return (
                <Route key={path} element={<AuthRouteWrapper />}>
                  <Route path={path} Component={WrappedComponent} />
                </Route>
              );
            case "ProtectedRoute":
              return (
                <Route key={path} element={<ProtectedRouteWrapper />}>
                  <Route path={path} Component={WrappedComponent} />
                </Route>
              );
            default:
              return (
                <Route key={path} path={path} Component={WrappedComponent} />
              );
          }
        })}
    </Routes>
  );
};

export default NavigationManager;
